import { defineStore } from 'pinia'
import { MassPaymentState, MassPaymentStore } from '@/modules/massPayment/types/store/MassPaymentStore'
import MassPaymentInvoiceItem from '@/modules/massPayment/entities/MassPaymentInvoiceItem'
import { MassPaymentItemI } from '@/modules/massPayment/types/api/MassPaymentInvoiceItemI'
import { CreateMassPaymentPayload } from './types/api/CreateMassPaymentPayload'

export const useMassPaymentStore: MassPaymentStore = defineStore('massPayment', {
  state: () =>
    ({
      massPaymentInvoice: null,
      isEnableMassPay: null,
      massPaymentIds: [] as number[],
    }) as MassPaymentState,
  getters: {
    getMassPaymentInvoiceItem(state) {
      return state.massPaymentInvoice ?? null
    },
    getMassPaymentInvoiceSubTotal(state) {
      return state.massPaymentInvoice
        ?.filter((item: MassPaymentInvoiceItem) => state.massPaymentIds.includes(item.invoiceid))
        .reduce((acc: number, val: MassPaymentInvoiceItem): number => acc + +val.subtotal, 0)
    },
    getMassPaymentInvoiceTax(state) {
      return state.massPaymentInvoice
        ?.filter((item: MassPaymentInvoiceItem) => state.massPaymentIds.includes(item.invoiceid))
        .reduce((acc: number, val: MassPaymentInvoiceItem): number => acc + +val.tax, 0)
    },
    /**
     * VAT is a per-customer rate, so the eligible invoices normally all carry the same one. The
     * summary only labels a percentage when the selection agrees on it; a mixed selection gets none.
     */
    getMassPaymentInvoiceTaxRate(state) {
      const rates = state.massPaymentInvoice
        ?.filter((item: MassPaymentInvoiceItem) => state.massPaymentIds.includes(item.invoiceid))
        .map((item: MassPaymentInvoiceItem) => Number(item.taxrate))
        .filter((rate: number) => !Number.isNaN(rate))

      if (!rates?.length) return null

      return rates.every((rate: number) => rate === rates[0]) ? rates[0] : null
    },
    getMassPaymentInvoiceCredit(state) {
      console.log(state.massPaymentInvoice)
      return state.massPaymentInvoice
        ?.filter((item: MassPaymentInvoiceItem) => state.massPaymentIds.includes(item.invoiceid))
        ?.reduce((acc: number, val: MassPaymentInvoiceItem): number => acc + +val.credit, 0)
    },
    getMassPaymentInvoiceTotal(state) {
      return state.massPaymentInvoice
        ?.filter((item: MassPaymentInvoiceItem) => state.massPaymentIds.includes(item.invoiceid))
        .reduce((acc: number, val: MassPaymentInvoiceItem): number => acc + +val.total, 0)
    },
  },
  actions: {
    async getMassPaymentInvoice() {
      const response = await this.$services.massPayment.loadMassPaymentInvoice()
      if (response instanceof Error) {
        return response
      }
      this.massPaymentInvoice = response.invoices.map((item: MassPaymentItemI) => new MassPaymentInvoiceItem(item))
      this.isEnableMassPay = response.isEnableMassPay
    },
    async createMassPaymentInvoice(ids: CreateMassPaymentPayload) {
      return await this.$services.massPayment.createMassPaymentInvoice(ids)
    },
  },
})
